import styles from "./styles/subscription-feature.module.scss";
import tickIcon from "@/assets/subscriptions/tick.svg";
import Image from "next/image";

interface SubscriptionFeatureProps {
  feature: string;
}

const SubscriptionFeature = ({ feature }: SubscriptionFeatureProps) => {
  return (
    <div className={styles.feature_wrapper}>
      <Image src={tickIcon} alt={""} />
      <div>{feature}</div>
    </div>
  );
};

export default SubscriptionFeature;
